import { SystemPrivilege } from '@/entities/authentication';
import { privilegeGuardRoute } from '@/features/authenticate';
import { ClientGroupsPage } from '@/pages/client-groups/list';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_private/manage/client-groups/')({
  component: ClientGroupsPage,
  beforeLoad: () =>
    privilegeGuardRoute({
      privileges: [SystemPrivilege.ViewClientGroup],
    }),
});
